<template>
  <div>
    <!-- Ver.3.1.0 新設ヘッダー -->
    <header>
      <div>
        <ul id="pc_header_menu">
          <li id="corporate_brand">
            <img :src="app_root + '/assets/common/img/epsonlogo.svg'" />
          </li>
          <li id="setupnavi_link">
            <a v-on:click="trackGaEvent('setupnavi')"
            href="https://support.epson.net/setupnavi/">Setup Navi</a>
          </li>
          <li id="gallery_link">
            <a
              v-on:click="clickLink('gallery')">Gallery</a>
          </li>

          <li id="createplus_link"> 
            <a 
              v-on:click="clickLink('create')">Create+</a>
          </li>
        </ul>

        <!-- ハンバーガーメニューブロック -->
        <ul id="sd_header_menu">
          <li>
            <div class="hamburger-menu">
              <input type="checkbox" id="menu-btn-check" v-model="checked"/>
              <label for="menu-btn-check" class="menu-btn"><span></span></label>

              <!-- ハンバーガーメニュー中身 -->
              <div class="menu-content">
                <ul>
                  <li id="menu_setupnavi_link">
                    <a v-on:click="trackGaEvent('setupnavi')"
                    href="https://support.epson.net/setupnavi/">Setup Navi</a>
                  </li>
                  <li id="menu_gallery_link">
                    <a v-on:click="clickLink('gallery')">Gallery</a>
                  </li>
                  <li id="menu_createplus_link">
                    <a v-on:click="clickLink('create')">Create+</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
         <!-- /ハンバーガーメニューブロック -->
      </div>
    </header>
    <!-- /Ver.3.1.0 新設ヘッダー -->
    <slot></slot>

    <div class="container">
      <footer>
        <LabelSiteFooter />
      </footer>
    </div>
  </div>
</template>

<script>
import LabelSiteFooter from "../components/LabelSiteFooter";
import ClientHelper from '../common/client.helper'
export default {
  name: "BaseCommonPage",
  components: {
    LabelSiteFooter
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isOpen: false,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    checked: {
      get () {
        return this.$store.state.showHumbugerMenu
      },
      set (value) {
        this.$store.commit('setShowHumbugerMenu', value)
      }
    },
  },
  methods: {
    toggleMenu: function () {
      this.isOpen = !this.isOpen;
    },
    clickLink: function (site_name) {
      let routerPath = ""
      if (site_name == "gallery") {
        routerPath = "/"
      }else if (site_name == "create"){
        routerPath = "/createplus/"
      }
      this.trackGaEvent(site_name)
      this.checked = false
      
      let defaultLanguage = ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage())
      this.$store.dispatch('messages/fetchMessages', { lg2: defaultLanguage, locale: this.$store.state.locale })
      this.$store.dispatch('createplusMessages/fetchMessages', { lg2: defaultLanguage, locale: this.$store.state.locale })
      this.$store.commit('changeLanguage', defaultLanguage)

      let routerPathLang = routerPath + defaultLanguage +"/"
      if(this.$route.path !== routerPathLang){
        this.$router.push({ 
          path: routerPath,
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
        });
      }
    },
    trackGaEvent: function (site_name) {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "gnavi",
        "custom_parameter2": site_name
      })
    },
  },
};
</script>

<style>
a {
  cursor: pointer;
}
</style>
